import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/justservicelogo.png';
import './Business.css';

export default function BusinessLanding() {
  const navigate = useNavigate();
  const [showLocationPopup, setShowLocationPopup] = useState(false);

  return (
    <div className="biz-landing">
      {/* Hero Banner */}
      <div className="biz-landing-hero">
        <div className="biz-landing-brand">
          <img src={logo} alt="Just Service" className="biz-landing-logo" />
          <span className="biz-landing-brand-name">Just<span>Service</span></span>
        </div>
        <h1>Welcome to Just Service!</h1>
        <h2>List &amp; Grow your Business FREE</h2>
        <p>We're excited to showcase your business to our community.</p>
      </div>

      {/* Content */}
      <div className="container biz-landing-body">
        <div className="biz-landing-left">
          <h3>Enhanced Business Information</h3>
          <p>
            Just Service allows you to provide detailed information about your business, such as
            contact details, business hours, services offered, and customer reviews. This
            comprehensive information helps potential customers make informed decisions.
          </p>

          <h3>Key Advantages</h3>
          <ul className="biz-advantages">
            <li>✅ Just Service provides consistent and accurate business information.</li>
            <li>✅ Improves your visibility in local search rankings.</li>
            <li>✅ Displays essential business info like name, address, phone number, and hours.</li>
            <li>✅ Allows appropriate categorization for your business.</li>
            <li>✅ Drives more targeted and qualified leads to your business.</li>
          </ul>

          <h3>Customer Reviews &amp; Feedback</h3>
          <p>Positive reviews can attract more customers, while negative feedback helps improve your services.</p>

          <button className="btn-list-business" onClick={() => setShowLocationPopup(true)}>
            List Your Business
          </button>
        </div>

        <div className="biz-landing-right">
          <div className="biz-info-card free">FREE<br />Listing</div>
          <div className="biz-info-card blue">
            Select business type :-<br />
            Seller<br />Trader<br />Manufacturer<br />Manufacturer/Trader<br />Trader/Seller<br />Service Provider
          </div>
          <div className="biz-info-card pink">Multiple category and Sub-Category</div>
          <div className="biz-info-card yellow">Offering Product &amp; services</div>
        </div>
      </div>
      {showLocationPopup && (
        <div className="modal-overlay" onClick={() => setShowLocationPopup(false)}>
          <div className="location-popup" onClick={e => e.stopPropagation()}>
            <button className="location-popup-close" onClick={() => setShowLocationPopup(false)}>✕</button>
            <div className="location-popup-header">Business Location Confirmation</div>
            <p className="location-popup-text">Are you currently at your business location?</p>
            <div className="location-popup-actions">
              <button className="location-btn yes" onClick={() => { setShowLocationPopup(false); navigate('/add-business?autofill=true'); }}>Yes</button>
              <button className="location-btn no" onClick={() => { setShowLocationPopup(false); navigate('/add-business'); }}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
